<!-- Card Header -->
@if (header) {
  <ng-content select="zeva-card-header, [zeva-card-header]"></ng-content>
}
<!-- Card Body -->
<div class="card-body">
  <ng-content></ng-content>
</div>
<!-- Card Footer -->
@if (footer) {
  <ng-content select="zeva-card-footer, [zeva-card-footer]"></ng-content>
}

<div class="active-indicator"></div>
